module.exports = __webpack_public_path__ + "img/tu07.9ad509e8.png";